<div class="w-[1000px]" [ngClass]="setHeight ? 'h-[580px]' : ''">
  <div class="py-24">
    <div class="flex items-center flex-col justify-center gap-2">
      @if(show_title){
      <p class="font-bold text-2xl">One moment while we Kinnect Ai processes this</p>

      }@else{ @if(username){
      <p class="font-bold text-2xl">
        One moment while we generate an account for <span class="text-k-blue"> {{ username }}</span>
      </p>
      } @if(formName){
      <p class="font-bold text-2xl">
        One moment while we create <span class="text-k-blue"> {{ formName }}</span>
      </p>

      } }

      <ng-lottie [options]="animation" width="235px" height="235px" class="w-[235px] h-[235px]"></ng-lottie>

      <p class="m-0 text-[18px] font-semibold text-[#707070]">This process should only take a few seconds...</p>
    </div>
  </div>
</div>
